import { FunctionComponent } from "react"

interface Props {
  label?: string
  input: any
  icon?: any
  optionSize?: number
  onClick?: Function
  remainder?: string
  color?: string
  isMobileSized?: boolean
  ieltsQe?: boolean
}

const CustomInputSelectionCheckboxV8: FunctionComponent<Props> = ({
  label,
  input,
  icon,
  remainder,
  onClick,
  color,
  ieltsQe,
}) => {
  return (
    <>
      <div className="flex justify-start items-center">
        <label className=" w-full">
          <label className="checkbox-label my-2 w-full">
            <input
              className=" w-full "
              type="checkbox"
              {...input}
              onClick={onClick}
            />
            <span className="checkbox-custom rectangular"></span>
            {label && (
              <div
                className={`bg-white  border text-font14 text-center md:px-4 px-3 bold input-reaction cursor-pointer w-full md:w-[498px] grid-layout min-h-fit ${
                  ieltsQe
                    ? "shadow-[0px_4px_8px_rgba(67,54,149,0.08)] rounded-lg m-auto"
                    : "gap-y-3 rounded"
                } py-4 justify-between md:flex md:gap-x-4 md:justify-around`}
              >
                <div className="flex grid-area-a">
                  <p
                    className={`${
                      typeof icon == "string" ? "" : "md:py-0 py-0 my-auto mx-0"
                    } leading-none md:w-auto text-black text-center text-font16`}
                  >
                    {label}
                  </p>
                </div>
                {remainder && (
                  <div
                    className={`rounded-22 border px-3 text-[11px] md:text-[12px] grid-area-b`}
                    style={
                      color
                        ? {
                            borderColor: color,
                            color: color,
                          }
                        : {}
                    }
                  >
                    {remainder}
                  </div>
                )}
                {!icon && (
                  <div className="flex justify-end flex-grow-[2] grid-area-c">
                    <img
                      className=""
                      src= {`${process.env.CDN_URL}/assets/icons/v8/blueArrow.svg`}
                      width="14"
                      height="14"
                      alt="logo"
                    />
                  </div>
                )}
              </div>
            )}
          </label>
        </label>
        <style jsx>{`
          checkbox-container {
            float: left;
            width: 50%;
            box-sizing: border-box;
            text-align: center;
            padding: 90px 0px;

            border: 1px solid red;
          }
          .grid-layout {
            display: grid;
            grid-template-areas: "a c" "b c";
          }
          .grid-area-a {
            grid-area: a;
          }
          .grid-area-b {
            grid-area: b;
          }
          .grid-area-c {
            grid-area: c;
          }
          /* Styling Checkbox Starts */
          .checkbox-label {
            display: block;
            position: relative;
            cursor: pointer;
            font-size: 22px;
            line-height: 24px;
            clear: both;
          }

          .checkbox-label input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
          }

          .checkbox-label .input-reaction {
            border: 1px solid #d6d5e5;
          }
          .checkbox-label input:checked ~ .input-reaction {
            background-color: #e3e4ff;
            border: 2px solid #494fe3;
          }
          .flag-img {
            height: 24px;
            width: 36.63px;
            margin: 0 auto;
          }

          @media only screen and (max-device-width: 768px) {
            .input-with-icon {
              width: 300px;
              height: 72px;
              padding: 10px 0px;
            }
          }
          @media only screen and (min-device-width: 769px) {
            .input-with-icon {
              width: 350px;
              height: 100px;
              padding: 16px 0px;
            }
            .grid-layout {
              display: flex;
            }
          }
          @media only screen and (max-device-width: 768px) {
            .input-without-icon {
              width: 300px;
              min-height: 48px;
            }
          }
          @media only screen and (min-device-width: 769px) {
            .input-without-icon {
              width: 498px;
              height: 52px;
            }
          }
        `}</style>
      </div>
    </>
  )
}

export default CustomInputSelectionCheckboxV8
